import { Link } from 'gatsby';
import * as React from 'react';

export default function StoryBlokLink({ link, children, className }) {
  const {
    url,
    cached_url,
    linktype
  } = link || {};

  let target = url;
  if (linktype == "story") {
    target = cached_url
  }

  if (!target.includes("http:") && !target.includes("https:") && !target.startsWith('/')) {
    target = '/'+target;
  }

  return (
    <Link to={target} className={className}>
      { children }
    </Link>
  );
}
